export function openCookieConsentModal () {
  if (!document.getElementById('cookie-consent-modal')) return;
  $('#cookie-consent-modal').foundation('open')
  document.documentElement.classList.remove('is-reveal-open')
}
